import React from "react";

export default function Description({ description }) {
  return (
    <>
      <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
    </>
  );
}
